import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useFleetVehicles(companyId?: string) {
  return useQuery({
    queryKey: ['fleet-vehicles', companyId],
    queryFn: async () => {
      if (!companyId) return [];
      
      const { data, error } = await supabase
        .from('fleet_vehicles')
        .select('id, plate, make, model, odometer')
        .eq('company_id', companyId)
        .eq('status', 'active')
        .order('plate');
      
      if (error) throw error;
      return data || [];
    },
    enabled: !!companyId
  });
}

export function useFleetDrivers(companyId?: string) {
  return useQuery({
    queryKey: ['fleet-drivers', companyId],
    queryFn: async () => {
      if (!companyId) return [];
      
      const { data, error } = await supabase
        .from('fleet_drivers')
        .select('id, name, cpf')
        .eq('company_id', companyId)
        .eq('status', 'active')
        .order('name');
      
      if (error) throw error;
      return data || [];
    },
    enabled: !!companyId
  });
}
